<script>
  import PlayerList from './PlayerList.svelte';
  import Board from './Board.svelte';
  import { game, user } from '../store/store';
  import Game from '../model/Game';
  import { startGame, leaveGame } from '../common/game_common';

</script>

<article class="board">
  <Board />
</article>

<nav class="game-nav">
  <div class="players">
    <div class="user-sess">{$user.playerName}</div>
    <!-- <button class="button-nav" style="align-self: flex-end; margin: 5px;">Logout</button> -->
    <PlayerList />
  </div>
  <div class="game-option">
    <div class="game-code">
      <div class="game-code-label">Game&nbsp;Code:</div>
      <div class="game-code-value">{$game.option.code}</div>
    </div>
    <div class="game-option-nav">
      <button class="button-nav" on:click={leaveGame}>NEW</button>
      <button class="button-nav" on:click={leaveGame}>LEAVE</button>
    </div>
  </div>
</nav>

<style>
  .board {
    height: 80%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .game-nav {
    min-height: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(250, 235, 215, 1);
  }

  .players {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 100%;
  }

  .game-option {
    display: flex;
    flex-direction: row;
    margin-top: 1em;
    margin-bottom: 1em;
    padding-bottom: 1em;
    width: 100%;
    justify-content: space-around;
  }

  .game-code {
    display: flex;
    flex-direction: row;
  }

  .game-code-label {
    padding: 0;
  }

  .game-code-value {
    margin-left: 5%;
    font-size: 1.2em;
  }

  .game-option-nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 0em;  
  }


  @media only screen and (min-width: 1000px) {
    .board {
      width: 80%;
      height: 100%;
      flex-direction: column;
    }
    .game-nav {
      width: 20%;
      height: 100%;
      flex-direction: column;      
    }
    .players {
      flex-direction: column;
      width: auto;
    }

    .game-option {
      flex-direction: column;
      align-items: center;    
    }

    .game-option-nav {
      margin-top: 2em;  
    }

  }
  .button-nav {    
    margin-left: 10%;
    width: 50%;
    padding: 0.5em;
  }

  .user-sess{
    margin-top: 1em;
    font-size: 1.5em;
    border-left: 1em solid var(--player-color, inherite);
    padding-left: 0.5em;
  }

</style>